import React from 'react';
import {Helmet} from "react-helmet";

const SEO = (props) => {

    const renderVideoMeta = () => {
        if (props.videoURL) {
            return <meta property="og:video" content={props.videoURL} />
        } else {
            return ""
        }
    }

    const renderTypeMeta = () => {
        if (props.type) {
            return <meta property="og:type" content={props.type} />
        } else {
            return ""
        }
    }

    // const renderRobots = () => {
    //     if (props.robots && props.robots === "false") {
    //         return <meta name="robots" content="noindex, nofollow" />
    //     } else {
    //         return <meta name="robots" content="index, follow" />
    //     }
    // }

   return (
    <Helmet>
        <title>{props.pageTitle}</title>
        <meta name="description" content={props.pageDesc} />
        <link rel="canonical" href={props.pageURL} />
        <meta name="twitter:site" content="@cpac_tv" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={props.title} />
        <meta name="twitter:description" content={props.pageDesc} />
        <meta name="twitter:image" content={props.image} />
        <meta property="og:url" content={props.pageURL} />
        {renderTypeMeta()}
        <meta property="og:locale" content={props.pageLocale} />
        <meta property="og:title" content={props.title} />
        <meta property="og:description" content={props.pageDesc} />
        <meta property="og:image" content={props.image} />
        {renderVideoMeta()}
        
    </Helmet>
    )
}

export default SEO;